module.exports = __webpack_public_path__ + "static/img/wander.d1269ec8.png";